import { render, staticRenderFns } from "./Списание за период.vue?vue&type=template&id=35332e51&scoped=true"
import script from "./Списание за период.vue?vue&type=script&lang=js"
export * from "./Списание за период.vue?vue&type=script&lang=js"
import style0 from "./Списание за период.vue?vue&type=style&index=0&id=35332e51&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35332e51",
  null
  
)

export default component.exports